import clsx from 'clsx';

interface ITabsItemProps {
  text: string;
  active: boolean;
  withBackground?: boolean;
  onClick: () => void;
}

export const TabsItem = (props: ITabsItemProps) => {
  return (
    <li
      className={clsx(
        'flex-none p-6 cursor-pointer relative ',
        props.active
          ? 'flex-none p-6 cursor-pointer relative  opacity-100 text-soft-black dark:text-white font-medium  bg-white dark:bg-soft-black'
          : 'text-silver',
        props.active && props.withBackground && 'bg-white dark:bg-soft-black',
      )}
      onClick={props.onClick}
    >
      {props.text}
    </li>
  );
};
